export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/ob-step-14.png?a4a197bd095f9656bb5d3a3e34e9d2fb";